// apiSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  successMessage: '',
  errorMessage: '',
  moreMessage: {}
};

const toastSlice = createSlice({
  name: 'api',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true;
      state.successMessage = '';
      state.errorMessage = '';
    },
    showSuccessMessage: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload;
      state.errorMessage = '';
    },
    showErrorMessage: (state, action) => {
      state.isLoading = false;
      state.successMessage = '';
      state.errorMessage = action.payload;
    },
    showMoreMessage: (state, action: any) => {
      state.isLoading = false;
      state.successMessage = '';
      state.moreMessage = action.payload;
    }
  }
});

export const { startLoading, showSuccessMessage, showErrorMessage, showMoreMessage } = toastSlice.actions;

export default toastSlice.reducer;
